const footerI18n = {
  "fr": {
    "baseline": "Rachat d’écrans & pièces détachées pour professionnels. Estimation immédiate, envoi guidé et paiement rapide, en toute transparence.",
    "nav": {
      "title": "Navigation"
    },
    "links": {
      "services": "Nos services",
      "pricing": "Tarifs",
      "secureSend": "Envoi sécurisé",
      "criteria": "Critères de rachat",
      "myShipments": "Mes envois",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Contact",
      "hours": "Du lundi au vendredi, 9h–18h (CET).",
      "email_aria": "Email"
    },
    "legal": {
      "rights": "Tous droits réservés",
      "terms": "Conditions générales de rachat",
      "mentions": "Mentions légales"
    },
    "bottom": {
      "notice": "Site destiné exclusivement aux professionnels."
    }
  },
  "en": {
    "baseline": "Buyback of screens & spare parts for professionals. Instant quote, guided shipping and fast payment, with full transparency.",
    "nav": {
      "title": "Navigation"
    },
    "links": {
      "services": "Our services",
      "pricing": "Pricing",
      "secureSend": "Secure shipping",
      "criteria": "Buyback criteria",
      "myShipments": "My shipments",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Contact",
      "hours": "Monday to Friday, 9am–6pm (CET).",
      "email_aria": "Email"
    },
    "legal": {
      "rights": "All rights reserved",
      "terms": "General buyback terms",
      "mentions": "Legal notice"
    },
    "bottom": {
      "notice": "Website intended for professionals only."
    }
  },
  "pl": {
    "baseline": "Odkup wyświetlaczy i części zamiennych dla profesjonalistów. Natychmiastowa wycena, prowadzone nadawanie i szybka płatność, z pełną przejrzystością.",
    "nav": {
      "title": "Nawigacja"
    },
    "links": {
      "services": "Nasze usługi",
      "pricing": "Cennik",
      "secureSend": "Bezpieczna wysyłka",
      "criteria": "Kryteria odkupu",
      "myShipments": "Moje przesyłki",
      "cookies": "Pliki cookie"
    },
    "contact": {
      "title": "Kontakt",
      "hours": "Od poniedziałku do piątku, 9:00–18:00 (CET).",
      "email_aria": "Email"
    },
    "legal": {
      "rights": "Wszelkie prawa zastrzeżone",
      "terms": "Ogólne warunki odkupu",
      "mentions": "Informacje prawne"
    },
    "bottom": {
      "notice": "Strona przeznaczona wyłącznie dla profesjonalistów."
    }
  },
  "es": {
    "baseline": "Recompra de pantallas y piezas de repuesto para profesionales. Valoración inmediata, envío guiado y pago rápido, con total transparencia.",
    "nav": {
      "title": "Navegación"
    },
    "links": {
      "services": "Nuestros servicios",
      "pricing": "Tarifas",
      "secureSend": "Envío seguro",
      "criteria": "Criterios de recompra",
      "myShipments": "Mis envíos",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Contacto",
      "hours": "De lunes a viernes, 9h–18h (CET).",
      "email_aria": "Email"
    },
    "legal": {
      "rights": "Todos los derechos reservados",
      "terms": "Condiciones generales de recompra",
      "mentions": "Aviso legal"
    },
    "bottom": {
      "notice": "Sitio destinado exclusivamente a profesionales."
    }
  },
  "it": {
    "baseline": "Riacquisto di schermi e ricambi per professionisti. Valutazione immediata, spedizione guidata e pagamento rapido, nella massima trasparenza.",
    "nav": {
      "title": "Navigazione"
    },
    "links": {
      "services": "I nostri servizi",
      "pricing": "Prezzi",
      "secureSend": "Spedizione sicura",
      "criteria": "Criteri di riacquisto",
      "myShipments": "Le mie spedizioni",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Contatto",
      "hours": "Dal lunedì al venerdì, dalle 9 alle 18 (CET).",
      "email_aria": "Email"
    },
    "legal": {
      "rights": "Tutti i diritti riservati",
      "terms": "Condizioni generali di riacquisto",
      "mentions": "Note legali"
    },
    "bottom": {
      "notice": "Sito web destinato esclusivamente ai professionisti."
    }
  },
  "de": {
    "baseline": "Rückkauf von Bildschirmen & Ersatzteilen für Profis. Sofortiges Angebot, geführter Versand und schnelle Zahlung, mit voller Transparenz.",
    "nav": {
      "title": "Navigation"
    },
    "links": {
      "services": "Unsere Dienstleistungen",
      "pricing": "Preisgestaltung",
      "secureSend": "Sicherer Versand",
      "criteria": "Rückkaufkriterien",
      "myShipments": "Meine Sendungen",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Kontakt",
      "hours": "Montag bis Freitag, 9–18 Uhr (MEZ).",
      "email_aria": "E-Mail"
    },
    "legal": {
      "rights": "Alle Rechte vorbehalten",
      "terms": "Allgemeine Ankaufsbedingungen",
      "mentions": "Impressum"
    },
    "bottom": {
      "notice": "Website nur für Profis gedacht."
    }
  },
  "pt": {
    "baseline": "Compra de ecrãs e peças de reposição para profissionais. Cotação instantânea, transporte guiado e pagamento rápido, com total transparência.",
    "nav": {
      "title": "Navegação"
    },
    "links": {
      "services": "Os nossos serviços",
      "pricing": "Preços",
      "secureSend": "Transporte seguro",
      "criteria": "Critérios de recompra",
      "myShipments": "Os meus envios",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Contacto",
      "hours": "Segunda a sexta-feira, das 9h às 18h (CET).",
      "email_aria": "E- mail"
    },
    "legal": {
      "rights": "Todos os direitos reservados",
      "terms": "Condições gerais de recompra",
      "mentions": "Aviso jurídico"
    },
    "bottom": {
      "notice": "Site destinado apenas para profissionais."
    }
  },
  "cs": {
    "baseline": "Nákup obrazovek a náhradních dílů pro profesionály. Okamžitá citace, průvodcovské a rychlé platby, s plnou průhledností.",
    "nav": {
      "title": "Navigace"
    },
    "links": {
      "services": "Naše služby",
      "pricing": "Ceny",
      "secureSend": "Bezpečná přeprava",
      "criteria": "Kritéria zpětného odkupu",
      "myShipments": "Moje zásilky",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Kontakt",
      "hours": "Od pondělí do pátku, od 9 do 18 hodin.",
      "email_aria": "E-mail"
    },
    "legal": {
      "rights": "Všechna práva vyhrazena",
      "terms": "Obecné podmínky zpětného odkupu",
      "mentions": "Právní upozornění"
    },
    "bottom": {
      "notice": "Stránky určené pouze pro profesionály."
    }
  },
  "nl": {
    "baseline": "Terugkopen van schermen en reserveonderdelen voor professionals. Direct offerte, geleide verzending en snelle betaling, met volledige transparantie.",
    "nav": {
      "title": "Navigatie"
    },
    "links": {
      "services": "Onze diensten",
      "pricing": "Prijzen",
      "secureSend": "Veilige verzending",
      "criteria": "Afkoopcriteria",
      "myShipments": "Mijn zendingen",
      "cookies": "Cookies"
    },
    "contact": {
      "title": "Contactpersoon",
      "hours": "Van maandag t/m vrijdag om 21.00 uur (CET).",
      "email_aria": "E-mail"
    },
    "legal": {
      "rights": "Alle rechten voorbehouden",
      "terms": "Algemene inkoopvoorwaarden",
      "mentions": "Mededeling"
    },
    "bottom": {
      "notice": "Website alleen voor professionals."
    }
  }
};

export default footerI18n;
